module.exports = __webpack_public_path__ + "img/edit-icon.318c85cd.svg";